













import { Vue, Component, Prop } from 'vue-property-decorator'
import { Link } from '../../reusable/types'

@Component({
  components: {}
})
export default class LinkComponent extends Vue {
  @Prop({ required: true }) public readonly productTitle!: string
  @Prop({ required: true }) public readonly link!: Link

  public doesIconExist = true

  public getImageSource () {
    return (this.doesIconExist) ? `./icons/links/${this.link.title}.png` : null
  }

  public handleIconLoadingError () {
    this.doesIconExist = false
  }
}
